import React from 'react';
import { classes } from '../../../utils/commonUtils';
import Loading from '../../loading/loading';
import css from './button.module.scss';

export interface ButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  /**
   * If `true`, the button will be in a loading state and the children will be replaced with a loading spinner.
   * Pass a number to set the size of the loading spinner.
   */
  isLoading?: boolean | number;
  isDisabled?: boolean;
  className?: string;
}

export function Button({ children, onClick, isLoading, isDisabled, className }: ButtonProps) {
  return (
    <button
      className={classes(css.button, className)}
      onClick={onClick}
      disabled={isDisabled}
      data-is-loading={isLoading}
    >
      {isLoading ? <Loading size={typeof isLoading === 'number' ? isLoading : 18} /> : children}
    </button>
  );
}
